// @flow
import type { Checker } from './validation/runtime-checks/index.js';
import { types as t } from './validation/runtime-checks/index.js';

// 🧪 Experimental checker. Don't use extensively.
//
// The general idea is there are some common constraints that we want to
// be able to express for strings.
//
// Its possible that a better approach would be to have
// something to the effect of t.strictString that we basically
// always use. I think it would be incredibly rare that we want
// to support the empty string, or a non-empty string that only
// contains whitespace.
//
// Another approach might be to make t.string have these qualities
// and have a t.permissiveString that matches to the type system
// concept of a string.
//
// Expected usage:
//
// stringWithConstraints({
//   mustContainNonWhitespaceChars: true,
//   banLeadingAndTrailingWhitespace: true,
// })
//
// TODO write tests for this matcher
export function stringWithConstraints(constraints: {|
  mustContainNonWhitespaceChars?: true,
  banLeadingAndTrailingWhitespace?: true,
|}): Checker {
  function stringWithConstraintsChecker(props, propName) {
    const maybeString = props[propName];

    const failure = t.string(props, propName);
    if (failure !== null) return failure;

    const string: string = (maybeString: any);

    const { mustContainNonWhitespaceChars, banLeadingAndTrailingWhitespace } =
      constraints;

    if (mustContainNonWhitespaceChars) {
      // Regex says the string matches if the string contains at least
      // one character that is NOT a whitespace characters
      if (string.match(/[^\s]/) === null) {
        return {
          typeDescription: stringWithConstraintsChecker.description,
          reason: 'must contain non-whitespace characters',
        };
      }
    }

    if (banLeadingAndTrailingWhitespace) {
      // Regex says the string matches if either:
      //  a) the string begins with a whitespace character OR
      //  b) the string ends with a whitespace character
      if (string.match(/(^\s|\s$)/) !== null) {
        return {
          typeDescription: stringWithConstraintsChecker.description,
          reason: 'must not have leading nor trailing whitespace',
        };
      }
    }

    return null;
  }
  stringWithConstraintsChecker.description = generateDescription(constraints);

  return stringWithConstraintsChecker;
}

function generateDescription(constraints: {|
  mustContainNonWhitespaceChars?: true,
  banLeadingAndTrailingWhitespace?: true,
|}) {
  const { mustContainNonWhitespaceChars, banLeadingAndTrailingWhitespace } =
    constraints;

  if (mustContainNonWhitespaceChars || mustContainNonWhitespaceChars) {
    const enforcedConstraints = [];
    if (mustContainNonWhitespaceChars) {
      enforcedConstraints.push('must contain non-whitespace characters');
    }
    if (banLeadingAndTrailingWhitespace) {
      enforcedConstraints.push('must not have leading nor trailing whitespace');
    }
    return 'A string that ' + enforcedConstraints.join(' and ');
  } else return 'string';
}
